import { get } from 'lodash'
import routes from '~/const/routes'

export const state = () => ({
  items: [],
  meta: {
    totalItems: null
  },
  requestParams: null
})

export const getters = {
  items: state => state.items,
  meta: state => state.meta,
  requestParams: state => state.requestParams
}

export const mutations = {
  RESET(state) {
    state.items = []
    state.meta = { totalItems: null }
    state.requestParams = null
  }
}

export const actions = {
  async getAll({ commit }, { documentId, config = {} }) {
    const signatures = get(
      await this.$axios.get(routes.documentsignature.concrete(documentId), config),
      'data'
    )

    commit(
      'AFTER_GET_ALL',
      {
        namespace: 'signatures',
        items: signatures,
        meta: null,
        params: config.params
      },
      { root: true }
    )

    return signatures
  }
}
